import { OnInit, Component, AfterViewInit } from '@angular/core';
import { environment } from 'environments/environment';
import { SsInventoryService } from 'shared/services/SS-Inventory/ss-inventory.service';
import { ReservationService } from 'shared/services/Reservations/reservations.service';
import { UserService } from 'shared/services/User/user.service';
import { MatDialog } from '@angular/material';
import { LoginModelComponent } from 'app/modules/widget/view-details/login-model/login-model.component';
import { AlertPopupService } from 'shared/services/SS-Alert/alert-popup.service';
import { AppComponent } from 'app/app.component';
declare var stripe: any;

@Component({
  selector: 'app-reservation-create',
  templateUrl: './create.component.html',
  styleUrls: ['./create.component.css']
})

export class CreateReservationComponent implements OnInit, AfterViewInit {
  imageURL: string = environment.URL_TEAM_IMAGES;
  packageObject;
  seatCounter: number;
  costPerSeat;
  totalCost;
  cardRef;
  loading: boolean;
  isLoggedIn: boolean;
  packageId: String = 'niners-2020';

  constructor(
    private inventory: SsInventoryService,
    private reservation: ReservationService,
    private us: UserService,
    private dialog: MatDialog,
    private alert: AlertPopupService,
    private app: AppComponent
  ) {
    this.loading = true;
    this.seatCounter = 1;
    this.inventory.getPackagedata('niners-2020').subscribe(res => {
      this.packageObject = res.teams;
      this.costPerSeat = this.packageObject.starting_price;
      this.updateTotal();
      this.loading = false;
    }, err => {
      this.loading = false;
      this.alert.errorAlertError('Error fetching package details');
    });

    this.us.authStateChange.subscribe(res => {
      this.updateState();
    }, err => {
      console.error(err);
      this.alert.errorAlert(err);
    });
  }

  decreaseCount() {
    if (this.seatCounter > 1) {
      this.seatCounter = this.seatCounter - 1;
    }
    this.updateTotal();
  }

  increaseCount() {
    if (this.seatCounter < 8) {
      this.seatCounter = this.seatCounter + 1;
    }
    this.updateTotal();
  }

  updateTotal() {
    this.totalCost = this.costPerSeat * this.seatCounter;
  }

  loginModal() {
    const login = this.dialog.open(LoginModelComponent, {
      width: '700px'
    });
    login.afterClosed().subscribe(res => {
      if (res) {
        this.alert.errorAlertSuccess('Successfully logged in');
      }
    });
  }

  loginFacebook() {
    this.us.initFbSignInFromAnywhere('/reservations/create');
  }

  proceedReservation() {
    // toggle loading
    this.app.toggleLoadingMsg('Reserving your seats');
    // stripe, generate token
    stripe.createToken(this.cardRef).then((result) => {
      if (result.error) {
        // STRIPE RROR
        // Inform the user if there was an error.
        const errorElement = document.getElementById('card-errors');
        errorElement.textContent = result.error.message;
        this.app.dismissLoading();
      } else {
        this.loading = false;
        // STRIPE SUCCESS, token generated, check if team auth exists
        const token = (result.token.id);
        this.reservation.create(this.packageId, this.seatCounter, token).subscribe(res => {
          this.app.dismissLoading();
          let msgText;
          if (this.seatCounter === 1) {
            msgText = 'Your reservation for ' + this.seatCounter + ' seat is confirmed. An email has been sent with reservation details.';
          } else {
            msgText = 'Your reservation for ' + this.seatCounter + ' seats is confirmed. An email has been sent with reservation details.';
          }
          this.alert.reservationSuccess(msgText);
        }, err => {
          this.alert.errorAlert(err.error.message);
          this.app.dismissLoading();
        });
      }
    });

  }

  updateState() {
    this.isLoggedIn = this.us.isLoggedIn();
    if (this.isLoggedIn === true) {
      setTimeout(() => {
        this.mountStripe();
      }, 200);
    }
  }


  ngOnInit() {
    this.isLoggedIn = this.us.isLoggedIn();
    const elements = stripe.elements();
    const style = {
      base: {
        color: '#32325d',
        fontFamily: 'Helvetica Neue, Helvetica, sans-serif',
        fontSmoothing: 'antialiased',
        fontSize: '16px',
        '::placeholder': {
          color: '#aab7c4'
        }
      },
      invalid: {
        color: '#fa755a',
        iconColor: '#fa755a'
      }
    };
    this.cardRef = elements.create('card', { style: style });
    this.cardRef.addEventListener('change', (event) => {
      const displayError = document.getElementById('card-errors');
      if (event.error) {
        displayError.textContent = event.error.message;
      } else {
        displayError.textContent = '';
      }
    });
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      if (this.isLoggedIn) {
        this.mountStripe();
      }
    }, 1200);

  }

  mountStripe() {
    this.cardRef.mount('#card-element');
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/reservations/create/create.component.ts